document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('MobileNavToggle');
  var mobileNav = document.getElementById('MobileNav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  var revealTargets = document.querySelectorAll(
    '.section-head, .collection-card, .review-card, .trust-item, .faq-item, .deal-strip'
  );
  revealTargets.forEach(function (el) { el.classList.add('reveal'); });

  var groupTargets = document.querySelectorAll(
    '.collections-grid, .products-grid, .carousel-row, .reviews-grid, .trust-grid'
  );
  groupTargets.forEach(function (el) { el.classList.add('reveal-group'); });

  var observed = document.querySelectorAll('.reveal, .reveal-group');
  if ('IntersectionObserver' in window && observed.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    observed.forEach(function (el) { io.observe(el); });
  } else {
    observed.forEach(function (el) { el.classList.add('in-view'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="add"], button[name="checkout"], .buy-now-btn');
    if (btn && !btn.disabled) {
      btn.classList.remove('pulse-added');
      void btn.offsetWidth;
      btn.classList.add('pulse-added');
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('form[action*="cart/add"]')) {
      var cartBadge = document.querySelector('.cart-count span');
      if (cartBadge) {
        cartBadge.classList.remove('bump');
        void cartBadge.offsetWidth;
        cartBadge.classList.add('bump');
      }
    }
  });
});
